/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareHomeHealthAdmission } from './MatrixCareHomeHealthAdmission';
import {
    MatrixCareHomeHealthAdmissionFromJSON,
    MatrixCareHomeHealthAdmissionFromJSONTyped,
    MatrixCareHomeHealthAdmissionToJSON,
    MatrixCareHomeHealthAdmissionToJSONTyped,
} from './MatrixCareHomeHealthAdmission';

/**
 * 
 * @export
 * @interface GetMatrixCareHomeHealthAdmission200Response
 */
export interface GetMatrixCareHomeHealthAdmission200Response {
    /**
     * 
     */
    data?: MatrixCareHomeHealthAdmission;
}

/**
 * Check if a given object implements the GetMatrixCareHomeHealthAdmission200Response interface.
 */
export function instanceOfGetMatrixCareHomeHealthAdmission200Response(value: object): value is GetMatrixCareHomeHealthAdmission200Response {
    return true;
}

export function GetMatrixCareHomeHealthAdmission200ResponseFromJSON(json: any): GetMatrixCareHomeHealthAdmission200Response {
    return GetMatrixCareHomeHealthAdmission200ResponseFromJSONTyped(json, false);
}

export function GetMatrixCareHomeHealthAdmission200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMatrixCareHomeHealthAdmission200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MatrixCareHomeHealthAdmissionFromJSON(json['data']),
    };
}

export function GetMatrixCareHomeHealthAdmission200ResponseToJSON(json: any): GetMatrixCareHomeHealthAdmission200Response {
    return GetMatrixCareHomeHealthAdmission200ResponseToJSONTyped(json, false);
}

export function GetMatrixCareHomeHealthAdmission200ResponseToJSONTyped(value?: GetMatrixCareHomeHealthAdmission200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MatrixCareHomeHealthAdmissionToJSON(value['data']),
    };
}

